import { FC } from 'react';
import {
    Datagrid,
    DatagridProps,
    DateField,
    DateInput,
    List,
    ListContextProvider,
    ListProps,
    NumberField,
    TextInput,
    TextField,
    useListContext,
    // ReferenceInput,
    ChipField,
    EmailField,
    Pagination,
    PaginationProps,
    // FunctionField,
} from 'react-admin';

import { makeStyles } from '@material-ui/core/styles';
import { Box, InputAdornment } from '@material-ui/core';
import { SearchOutlined } from '@material-ui/icons';

// import ColoredChipField from '../components/ColoredChip';
import ListActions from '../components/ToolbarActions';
import BulkActionButtons from '../components/BulkActions';
import { dateLocales, defaultDateOptions } from '../utils/formatters';
import ListLinkField from '../components/ListLinkField';

const merchantsFilters = [
    <TextInput
        source="id"
        alwaysOn
        style={{
            minWidth: '400px', //TODO: responsive
        }}
        InputProps={{
            endAdornment: (
                <InputAdornment position="end">
                    <SearchOutlined />
                </InputAdornment>
            ),
        }}
    />,
    <TextInput source="email" alwaysOn />,
    <TextInput source="name" alwaysOn />,
    <DateInput source="data#registration_month" />,
    <DateInput source="created_at@_gte" label="resources.common.fields.created_at@_gte" />,
    <DateInput source="created_at@_lte" label="resources.common.fields.created_at@_lte" />,
    <DateInput source="updated_at@_gte" label="resources.common.fields.updated_at@_gte" />,
    <DateInput source="updated_at@_lte" label="resources.common.fields.updated_at@_lte" />,
    <DateInput source="data#registration_month@_lte" label="resources.merchants.fields.registration_month@_lte" />,
    <DateInput source="data#registration_month@_gte" label="resources.merchants.fields.registration_month@_gte" />,
    <TextInput source="industry" />,
]

const useDatagridStyles = makeStyles(theme => ({
    total: { fontWeight: 'bold' },
    important: { fontWeight: 'bold' },
    email: { color: theme.palette.text.primary },
    chipImportant: {
        opacity: 0.7,
        '&:hover': {
            opacity: 1
        }
        // backgroundColor: colors.blue[200],
        // '& .MuiChip-label': { fontWeight: 'bold' },
    }
}));

interface TabbedDatagridProps extends DatagridProps { }

const ListDatagrid: FC<TabbedDatagridProps> = props => {
    const listContext = useListContext();
    // const {ids, filterValues, setFilters, displayedFilters} = listContext;
    const classes = useDatagridStyles(props);

    return (
        <ListContextProvider
            value={{ ...listContext }}
        >
            <Datagrid
                {...props}
                rowClick="edit"
                optimized
            // expand={<MerchantPanel />}
            >
                <NumberField source="id" label="resources.common.fields.id" />
                <DateField source="created_at" label="resources.common.fields.created_at" locales={dateLocales} options={defaultDateOptions} showTime />
                <DateField source="updated_at" label="resources.common.fields.updated_at" locales={dateLocales} options={defaultDateOptions} showTime />
                <TextField source="industry" />
                <ListLinkField
                    reference="financings"
                    target="merchant_id"
                    label="resources.merchants.fields.financings"
                    textAlign="center"
                >
                    <ChipField
                        size="small"
                        source="financings_aggregate.aggregate.count"
                        color="primary"
                        className={classes.chipImportant}
                    />
                </ListLinkField>
                <EmailField source="email" className={classes.email} />
                <TextField source="name" />
                <DateField source="data.registration_month" locales={dateLocales} options={defaultDateOptions} showTime />
            </Datagrid>
        </ListContextProvider>
    );
};


const MerchantList: FC<ListProps> = props => {
    const CustomPagination = (props: JSX.IntrinsicAttributes & PaginationProps) =>
        <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />;


    return <List
        {...props}
        component={Box}
        sort={{ field: 'updated_at', order: 'DESC' }}
        actions={<ListActions importer={false} />}
        pagination={<CustomPagination />}
        bulkActionButtons={<BulkActionButtons />}
        filters={merchantsFilters}
        perPage={50}
    >
        <ListDatagrid />
    </List>
}

export default MerchantList;
